import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

import { onMounted, ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'rn-text-control-loading',
  setup(__props) {

const isUpdating = ref(false);

onMounted(() => {
  const checkGoogle = () => {
    if (window.editorContext) {
      window.editorContext.text_controller.updating$()
        .subscribe(i => isUpdating.value = i);
      // You can now use window.google here or trigger any other necessary actions.
    } else {
      // If window.google is not available, retry after a delay
      setTimeout(checkGoogle, 1000); // Retry every second, adjust the delay as needed.
    }
  };

  // Start checking for window.google
  checkGoogle();
});

return (_ctx: any,_cache: any) => {
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!

  return (_openBlock(), _createElementBlock("div", null, [
    (isUpdating.value)
      ? (_openBlock(), _createBlock(_component_v_progress_circular, {
          key: 0,
          indeterminate: "",
          color: "primary"
        }))
      : _createCommentVNode("", true)
  ]))
}
}

})